import { render, staticRenderFns } from "./App.vue?vue&type=template&id=63250c6a&"
import script from "./App.vue?vue&type=script&setup=true&lang=ts&"
export * from "./App.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports